module.exports = __webpack_public_path__ + "img/9788946054905.18a5466d.jpg";